const UseCaseHospitalitySection = () => {
    return (
        <div>
        <section className="basic-area green-area">
            <div className="container">
                <div className="basic-flex progress">
                    <img
                        className="basic-flex-phone-screenshot"
                        style={{ width: "340px", height: "680px" }}
                        src="images/katalife-democafe-feedback.png"
                        alt="activities"
                    />

                    <div className="basic-flex__content">
                         <h2>
                            Katalife for Hospitality
                        </h2>
                        <ul>
                            <li>Gather actionable insight from your customers</li>
                            <li><strong>Optimised Hospitality Templates:</strong> Create a survey in minutes using our existing survey templates for Hospitality. </li>
                            <li ><br /></li>
                            <li><strong>Stand out from the rest:</strong>Know what your customers love and what they don’t. So you can wow your customers to drive business growth!</li>
                        </ul>                       
                    </div>
                </div>
            </div>
        </section>
         
    </div>
    );
};

export default UseCaseHospitalitySection;
